import { createAsyncThunk } from '@reduxjs/toolkit';

import { retailerService } from '@/services';
import { handleThunkApiError } from '@/utils';

export const retailerUpdateMedia = createAsyncThunk(
  'retailer/update-media',
  handleThunkApiError(retailerService.updateRetailerMedia),
);
